import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  border: {
    borderBottom: 1,
    borderColor: 'divider',
  },
  rootTab: {
    minHeight: '24px',
  },
  routeTab: {
    borderRadius: '5px 5px 0 0',
    padding: theme.spacing(1, 2),
    minHeight: '24px',
    '&:hover': {
      background: 'rgba(0, 0, 0, 0.03)',
    },
  },
  activeTab: {
    borderBottom: '2px solid',
  },
  actionButton: {
    marginBottom: theme.spacing(1.25),
  },
}));
